export const PARTITION_KEY = 'pk'
export const SORT_KEY = 'sk'

export const GSI1_INDEX_NAME = 'GSI1_INDEX'
export const GSI1_PARTITION_KEY = 'sk'
export const GSI1_SORT_KEY = 'pk'

export const GSI2_INDEX_NAME = 'GSI2_INDEX'
export const GSI2_PARTITION_KEY = 'mnemonicId'
export const GSI2_SORT_KEY = 'sk'

export const GSI3_INDEX_NAME = 'GSI3_INDEX'
export const GSI3_PARTITION_KEY = 'pk'
export const GSI3_SORT_KEY = 'created'

export const GSI4_INDEX_NAME = 'GSI4_INDEX'
export const GSI4_PARTITION_KEY = 'sk'
export const GSI4_SORT_KEY = 'created'

export const TIME_TO_LIVE = 'TTL'
